import "./v2-question-surface.css";

function GiftIcon() {
  return (
    <svg
      aria-hidden="true"
      className="tgc-v2-link-card-eyebrow__icon"
      viewBox="0 0 24 24"
      focusable="false"
    >
      <path d="M5 10h14v10H5z" />
      <path d="M4 6h16v4H4z" />
      <path d="M12 6v14" />
      <path d="M12 6c-1.8-3-5.5-2.1-4.7.5C7.8 8.2 10 7.7 12 6z" />
      <path d="M12 6c1.8-3 5.5-2.1 4.7.5C16.2 8.2 14 7.7 12 6z" />
    </svg>
  );
}

export default function LinkCard({ url, href = null }) {
  const card = href ? (
    <a className="tgc-v2-link-card" href={href} title={url} aria-label="Open the receiver preview">
      {url}
    </a>
  ) : (
    <div className="tgc-v2-link-card" title={url}>
      {url}
    </div>
  );

  return (
    <div className="tgc-v2-link-card-wrap">
      <div className="tgc-v2-link-card-eyebrow">
        <GiftIcon />
        <span>Your gift link</span>
        <GiftIcon />
      </div>
      {card}
    </div>
  );
}
